/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LocaleRouteImport } from './routes/$locale'
import { Route as LocaleIndexRouteImport } from './routes/$locale/index'
import { Route as LocaleValidateRouteImport } from './routes/$locale/validate'
import { Route as LocaleTermsRouteImport } from './routes/$locale/terms'
import { Route as LocaleSignupRouteImport } from './routes/$locale/signup'
import { Route as LocaleSigninRouteImport } from './routes/$locale/signin'
import { Route as LocaleRedirectRouteImport } from './routes/$locale/redirect'
import { Route as LocalePrivacyPolicyRouteImport } from './routes/$locale/privacy-policy'
import { Route as LocalePhysicalGoodsRouteImport } from './routes/$locale/physical-goods'
import { Route as LocaleManageRouteImport } from './routes/$locale/manage'
import { Route as LocaleListItemRouteImport } from './routes/$locale/list-item'
import { Route as LocaleHomeRouteImport } from './routes/$locale/home'
import { Route as LocaleHallOfFameRouteImport } from './routes/$locale/hall-of-fame'
import { Route as LocaleFeaturedRouteImport } from './routes/$locale/featured'
import { Route as LocaleFaqRouteImport } from './routes/$locale/faq'
import { Route as LocaleExplore2RouteImport } from './routes/$locale/explore2'
import { Route as LocaleExploreRouteImport } from './routes/$locale/explore'
import { Route as LocaleDmcaRouteImport } from './routes/$locale/dmca'
import { Route as LocaleDeployRouteImport } from './routes/$locale/deploy'
import { Route as LocaleCreateItemRouteImport } from './routes/$locale/create-item'
import { Route as LocaleContactRouteImport } from './routes/$locale/contact'
import { Route as LocaleConnectWalletRouteImport } from './routes/$locale/connect-wallet'
import { Route as LocaleAuthorsRouteImport } from './routes/$locale/authors'
import { Route as LocaleAcknowledgementsRouteImport } from './routes/$locale/acknowledgements'
import { Route as LocaleAboutRouteImport } from './routes/$locale/about'
import { Route as LocaleValidateIndexRouteImport } from './routes/$locale/validate/index'
import { Route as LocaleProfileIndexRouteImport } from './routes/$locale/profile/index'
import { Route as LocaleMintIndexRouteImport } from './routes/$locale/mint/index'
import { Route as LocaleCollectionsIndexRouteImport } from './routes/$locale/collections/index'
import { Route as LocaleWalletAddressRouteImport } from './routes/$locale/wallet/$address'
import { Route as LocaleValidateAuthInfoRouteImport } from './routes/$locale/validate/$authInfo'
import { Route as LocaleProfileUserIdRouteImport } from './routes/$locale/profile/$userId'
import { Route as LocaleMintDappIdRouteImport } from './routes/$locale/mint/$dappId'
import { Route as LocaleCollectionsNetworkSlugRouteImport } from './routes/$locale/collections/$networkSlug'
import { Route as LocaleCollectionSlugRouteImport } from './routes/$locale/collection/$slug'
import { Route as LocaleChainsXdcRouteImport } from './routes/$locale/chains/xdc'
import { Route as LocaleChainsSongbirdRouteImport } from './routes/$locale/chains/songbird'
import { Route as LocaleChainsMonadTestnetRouteImport } from './routes/$locale/chains/monad-testnet'
import { Route as LocaleChainsMonadRouteImport } from './routes/$locale/chains/monad'
import { Route as LocaleChainsFlareRouteImport } from './routes/$locale/chains/flare'
import { Route as LocaleChainsCoston2RouteImport } from './routes/$locale/chains/coston-2'
import { Route as LocaleChainsCostonRouteImport } from './routes/$locale/chains/coston'
import { Route as LocaleChainsAvalancheRouteImport } from './routes/$locale/chains/avalanche'
import { Route as LocaleChainsApothemRouteImport } from './routes/$locale/chains/apothem'
import { Route as LocaleAdminMintingDappsRouteImport } from './routes/$locale/admin/minting-dapps'
import { Route as LocaleCollectionsNetworkSlugIndexRouteImport } from './routes/$locale/collections/$networkSlug/index'
import { Route as LocaleCollectionsNetworkSlugCollectionSlugRouteImport } from './routes/$locale/collections/$networkSlug/$collectionSlug'
import { Route as LocaleCollectionChainSlugRouteImport } from './routes/$locale/collection/$chain/$slug'
import { Route as LocaleItemdetailsCollIdTokenIdPageRouteImport } from './routes/$locale/itemdetails/$collId/$tokenId/page'
import { Route as LocaleItemPhysicalSlugPageRouteImport } from './routes/$locale/item/physical/$slug/page'
import { Route as LocaleItemChainContractTokenIdIndexRouteImport } from './routes/$locale/item/$chain/$contract/$tokenId/index'

const LocaleRoute = LocaleRouteImport.update({
  id: '/$locale',
  path: '/$locale',
  getParentRoute: () => rootRouteImport,
} as any)
const LocaleIndexRoute = LocaleIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleValidateRoute = LocaleValidateRouteImport.update({
  id: '/validate',
  path: '/validate',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleTermsRoute = LocaleTermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSignupRoute = LocaleSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleSigninRoute = LocaleSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleRedirectRoute = LocaleRedirectRouteImport.update({
  id: '/redirect',
  path: '/redirect',
  getParentRoute: () => LocaleRoute,
} as any)
const LocalePrivacyPolicyRoute = LocalePrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => LocaleRoute,
} as any)
const LocalePhysicalGoodsRoute = LocalePhysicalGoodsRouteImport.update({
  id: '/physical-goods',
  path: '/physical-goods',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleManageRoute = LocaleManageRouteImport.update({
  id: '/manage',
  path: '/manage',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleListItemRoute = LocaleListItemRouteImport.update({
  id: '/list-item',
  path: '/list-item',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleHomeRoute = LocaleHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleHallOfFameRoute = LocaleHallOfFameRouteImport.update({
  id: '/hall-of-fame',
  path: '/hall-of-fame',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleFeaturedRoute = LocaleFeaturedRouteImport.update({
  id: '/featured',
  path: '/featured',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleFaqRoute = LocaleFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleExplore2Route = LocaleExplore2RouteImport.update({
  id: '/explore2',
  path: '/explore2',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleExploreRoute = LocaleExploreRouteImport.update({
  id: '/explore',
  path: '/explore',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleDmcaRoute = LocaleDmcaRouteImport.update({
  id: '/dmca',
  path: '/dmca',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleDeployRoute = LocaleDeployRouteImport.update({
  id: '/deploy',
  path: '/deploy',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleCreateItemRoute = LocaleCreateItemRouteImport.update({
  id: '/create-item',
  path: '/create-item',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleContactRoute = LocaleContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleConnectWalletRoute = LocaleConnectWalletRouteImport.update({
  id: '/connect-wallet',
  path: '/connect-wallet',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleAuthorsRoute = LocaleAuthorsRouteImport.update({
  id: '/authors',
  path: '/authors',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleAcknowledgementsRoute = LocaleAcknowledgementsRouteImport.update({
  id: '/acknowledgements',
  path: '/acknowledgements',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleAboutRoute = LocaleAboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleValidateIndexRoute = LocaleValidateIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LocaleValidateRoute,
} as any)
const LocaleProfileIndexRoute = LocaleProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleMintIndexRoute = LocaleMintIndexRouteImport.update({
  id: '/mint/',
  path: '/mint/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleCollectionsIndexRoute = LocaleCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleWalletAddressRoute = LocaleWalletAddressRouteImport.update({
  id: '/wallet/$address',
  path: '/wallet/$address',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleValidateAuthInfoRoute = LocaleValidateAuthInfoRouteImport.update({
  id: '/$authInfo',
  path: '/$authInfo',
  getParentRoute: () => LocaleValidateRoute,
} as any)
const LocaleProfileUserIdRoute = LocaleProfileUserIdRouteImport.update({
  id: '/profile/$userId',
  path: '/profile/$userId',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleMintDappIdRoute = LocaleMintDappIdRouteImport.update({
  id: '/mint/$dappId',
  path: '/mint/$dappId',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleCollectionsNetworkSlugRoute =
  LocaleCollectionsNetworkSlugRouteImport.update({
    id: '/collections/$networkSlug',
    path: '/collections/$networkSlug',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleCollectionSlugRoute = LocaleCollectionSlugRouteImport.update({
  id: '/collection/$slug',
  path: '/collection/$slug',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsXdcRoute = LocaleChainsXdcRouteImport.update({
  id: '/chains/xdc',
  path: '/chains/xdc',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsSongbirdRoute = LocaleChainsSongbirdRouteImport.update({
  id: '/chains/songbird',
  path: '/chains/songbird',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsMonadTestnetRoute =
  LocaleChainsMonadTestnetRouteImport.update({
    id: '/chains/monad-testnet',
    path: '/chains/monad-testnet',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleChainsMonadRoute = LocaleChainsMonadRouteImport.update({
  id: '/chains/monad',
  path: '/chains/monad',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsFlareRoute = LocaleChainsFlareRouteImport.update({
  id: '/chains/flare',
  path: '/chains/flare',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsCoston2Route = LocaleChainsCoston2RouteImport.update({
  id: '/chains/coston-2',
  path: '/chains/coston-2',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsCostonRoute = LocaleChainsCostonRouteImport.update({
  id: '/chains/coston',
  path: '/chains/coston',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsAvalancheRoute = LocaleChainsAvalancheRouteImport.update({
  id: '/chains/avalanche',
  path: '/chains/avalanche',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleChainsApothemRoute = LocaleChainsApothemRouteImport.update({
  id: '/chains/apothem',
  path: '/chains/apothem',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleAdminMintingDappsRoute = LocaleAdminMintingDappsRouteImport.update({
  id: '/admin/minting-dapps',
  path: '/admin/minting-dapps',
  getParentRoute: () => LocaleRoute,
} as any)
const LocaleCollectionsNetworkSlugIndexRoute =
  LocaleCollectionsNetworkSlugIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => LocaleCollectionsNetworkSlugRoute,
  } as any)
const LocaleCollectionsNetworkSlugCollectionSlugRoute =
  LocaleCollectionsNetworkSlugCollectionSlugRouteImport.update({
    id: '/$collectionSlug',
    path: '/$collectionSlug',
    getParentRoute: () => LocaleCollectionsNetworkSlugRoute,
  } as any)
const LocaleCollectionChainSlugRoute =
  LocaleCollectionChainSlugRouteImport.update({
    id: '/collection/$chain/$slug',
    path: '/collection/$chain/$slug',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleItemdetailsCollIdTokenIdPageRoute =
  LocaleItemdetailsCollIdTokenIdPageRouteImport.update({
    id: '/itemdetails/$collId/$tokenId/page',
    path: '/itemdetails/$collId/$tokenId/page',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleItemPhysicalSlugPageRoute =
  LocaleItemPhysicalSlugPageRouteImport.update({
    id: '/item/physical/$slug/page',
    path: '/item/physical/$slug/page',
    getParentRoute: () => LocaleRoute,
  } as any)
const LocaleItemChainContractTokenIdIndexRoute =
  LocaleItemChainContractTokenIdIndexRouteImport.update({
    id: '/item/$chain/$contract/$tokenId/',
    path: '/item/$chain/$contract/$tokenId/',
    getParentRoute: () => LocaleRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/about': typeof LocaleAboutRoute
  '/$locale/acknowledgements': typeof LocaleAcknowledgementsRoute
  '/$locale/authors': typeof LocaleAuthorsRoute
  '/$locale/connect-wallet': typeof LocaleConnectWalletRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/create-item': typeof LocaleCreateItemRoute
  '/$locale/deploy': typeof LocaleDeployRoute
  '/$locale/dmca': typeof LocaleDmcaRoute
  '/$locale/explore': typeof LocaleExploreRoute
  '/$locale/explore2': typeof LocaleExplore2Route
  '/$locale/faq': typeof LocaleFaqRoute
  '/$locale/featured': typeof LocaleFeaturedRoute
  '/$locale/hall-of-fame': typeof LocaleHallOfFameRoute
  '/$locale/home': typeof LocaleHomeRoute
  '/$locale/list-item': typeof LocaleListItemRoute
  '/$locale/manage': typeof LocaleManageRoute
  '/$locale/physical-goods': typeof LocalePhysicalGoodsRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/redirect': typeof LocaleRedirectRoute
  '/$locale/signin': typeof LocaleSigninRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/terms': typeof LocaleTermsRoute
  '/$locale/validate': typeof LocaleValidateRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/admin/minting-dapps': typeof LocaleAdminMintingDappsRoute
  '/$locale/chains/apothem': typeof LocaleChainsApothemRoute
  '/$locale/chains/avalanche': typeof LocaleChainsAvalancheRoute
  '/$locale/chains/coston': typeof LocaleChainsCostonRoute
  '/$locale/chains/coston-2': typeof LocaleChainsCoston2Route
  '/$locale/chains/flare': typeof LocaleChainsFlareRoute
  '/$locale/chains/monad': typeof LocaleChainsMonadRoute
  '/$locale/chains/monad-testnet': typeof LocaleChainsMonadTestnetRoute
  '/$locale/chains/songbird': typeof LocaleChainsSongbirdRoute
  '/$locale/chains/xdc': typeof LocaleChainsXdcRoute
  '/$locale/collection/$slug': typeof LocaleCollectionSlugRoute
  '/$locale/collections/$networkSlug': typeof LocaleCollectionsNetworkSlugRouteWithChildren
  '/$locale/mint/$dappId': typeof LocaleMintDappIdRoute
  '/$locale/profile/$userId': typeof LocaleProfileUserIdRoute
  '/$locale/validate/$authInfo': typeof LocaleValidateAuthInfoRoute
  '/$locale/wallet/$address': typeof LocaleWalletAddressRoute
  '/$locale/collections/': typeof LocaleCollectionsIndexRoute
  '/$locale/mint/': typeof LocaleMintIndexRoute
  '/$locale/profile/': typeof LocaleProfileIndexRoute
  '/$locale/validate/': typeof LocaleValidateIndexRoute
  '/$locale/collection/$chain/$slug': typeof LocaleCollectionChainSlugRoute
  '/$locale/collections/$networkSlug/$collectionSlug': typeof LocaleCollectionsNetworkSlugCollectionSlugRoute
  '/$locale/collections/$networkSlug/': typeof LocaleCollectionsNetworkSlugIndexRoute
  '/$locale/item/physical/$slug/page': typeof LocaleItemPhysicalSlugPageRoute
  '/$locale/itemdetails/$collId/$tokenId/page': typeof LocaleItemdetailsCollIdTokenIdPageRoute
  '/$locale/item/$chain/$contract/$tokenId/': typeof LocaleItemChainContractTokenIdIndexRoute
}
export interface FileRoutesByTo {
  '/$locale/about': typeof LocaleAboutRoute
  '/$locale/acknowledgements': typeof LocaleAcknowledgementsRoute
  '/$locale/authors': typeof LocaleAuthorsRoute
  '/$locale/connect-wallet': typeof LocaleConnectWalletRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/create-item': typeof LocaleCreateItemRoute
  '/$locale/deploy': typeof LocaleDeployRoute
  '/$locale/dmca': typeof LocaleDmcaRoute
  '/$locale/explore': typeof LocaleExploreRoute
  '/$locale/explore2': typeof LocaleExplore2Route
  '/$locale/faq': typeof LocaleFaqRoute
  '/$locale/featured': typeof LocaleFeaturedRoute
  '/$locale/hall-of-fame': typeof LocaleHallOfFameRoute
  '/$locale/home': typeof LocaleHomeRoute
  '/$locale/list-item': typeof LocaleListItemRoute
  '/$locale/manage': typeof LocaleManageRoute
  '/$locale/physical-goods': typeof LocalePhysicalGoodsRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/redirect': typeof LocaleRedirectRoute
  '/$locale/signin': typeof LocaleSigninRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/terms': typeof LocaleTermsRoute
  '/$locale': typeof LocaleIndexRoute
  '/$locale/admin/minting-dapps': typeof LocaleAdminMintingDappsRoute
  '/$locale/chains/apothem': typeof LocaleChainsApothemRoute
  '/$locale/chains/avalanche': typeof LocaleChainsAvalancheRoute
  '/$locale/chains/coston': typeof LocaleChainsCostonRoute
  '/$locale/chains/coston-2': typeof LocaleChainsCoston2Route
  '/$locale/chains/flare': typeof LocaleChainsFlareRoute
  '/$locale/chains/monad': typeof LocaleChainsMonadRoute
  '/$locale/chains/monad-testnet': typeof LocaleChainsMonadTestnetRoute
  '/$locale/chains/songbird': typeof LocaleChainsSongbirdRoute
  '/$locale/chains/xdc': typeof LocaleChainsXdcRoute
  '/$locale/collection/$slug': typeof LocaleCollectionSlugRoute
  '/$locale/mint/$dappId': typeof LocaleMintDappIdRoute
  '/$locale/profile/$userId': typeof LocaleProfileUserIdRoute
  '/$locale/validate/$authInfo': typeof LocaleValidateAuthInfoRoute
  '/$locale/wallet/$address': typeof LocaleWalletAddressRoute
  '/$locale/collections': typeof LocaleCollectionsIndexRoute
  '/$locale/mint': typeof LocaleMintIndexRoute
  '/$locale/profile': typeof LocaleProfileIndexRoute
  '/$locale/validate': typeof LocaleValidateIndexRoute
  '/$locale/collection/$chain/$slug': typeof LocaleCollectionChainSlugRoute
  '/$locale/collections/$networkSlug/$collectionSlug': typeof LocaleCollectionsNetworkSlugCollectionSlugRoute
  '/$locale/collections/$networkSlug': typeof LocaleCollectionsNetworkSlugIndexRoute
  '/$locale/item/physical/$slug/page': typeof LocaleItemPhysicalSlugPageRoute
  '/$locale/itemdetails/$collId/$tokenId/page': typeof LocaleItemdetailsCollIdTokenIdPageRoute
  '/$locale/item/$chain/$contract/$tokenId': typeof LocaleItemChainContractTokenIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$locale': typeof LocaleRouteWithChildren
  '/$locale/about': typeof LocaleAboutRoute
  '/$locale/acknowledgements': typeof LocaleAcknowledgementsRoute
  '/$locale/authors': typeof LocaleAuthorsRoute
  '/$locale/connect-wallet': typeof LocaleConnectWalletRoute
  '/$locale/contact': typeof LocaleContactRoute
  '/$locale/create-item': typeof LocaleCreateItemRoute
  '/$locale/deploy': typeof LocaleDeployRoute
  '/$locale/dmca': typeof LocaleDmcaRoute
  '/$locale/explore': typeof LocaleExploreRoute
  '/$locale/explore2': typeof LocaleExplore2Route
  '/$locale/faq': typeof LocaleFaqRoute
  '/$locale/featured': typeof LocaleFeaturedRoute
  '/$locale/hall-of-fame': typeof LocaleHallOfFameRoute
  '/$locale/home': typeof LocaleHomeRoute
  '/$locale/list-item': typeof LocaleListItemRoute
  '/$locale/manage': typeof LocaleManageRoute
  '/$locale/physical-goods': typeof LocalePhysicalGoodsRoute
  '/$locale/privacy-policy': typeof LocalePrivacyPolicyRoute
  '/$locale/redirect': typeof LocaleRedirectRoute
  '/$locale/signin': typeof LocaleSigninRoute
  '/$locale/signup': typeof LocaleSignupRoute
  '/$locale/terms': typeof LocaleTermsRoute
  '/$locale/validate': typeof LocaleValidateRouteWithChildren
  '/$locale/': typeof LocaleIndexRoute
  '/$locale/admin/minting-dapps': typeof LocaleAdminMintingDappsRoute
  '/$locale/chains/apothem': typeof LocaleChainsApothemRoute
  '/$locale/chains/avalanche': typeof LocaleChainsAvalancheRoute
  '/$locale/chains/coston': typeof LocaleChainsCostonRoute
  '/$locale/chains/coston-2': typeof LocaleChainsCoston2Route
  '/$locale/chains/flare': typeof LocaleChainsFlareRoute
  '/$locale/chains/monad': typeof LocaleChainsMonadRoute
  '/$locale/chains/monad-testnet': typeof LocaleChainsMonadTestnetRoute
  '/$locale/chains/songbird': typeof LocaleChainsSongbirdRoute
  '/$locale/chains/xdc': typeof LocaleChainsXdcRoute
  '/$locale/collection/$slug': typeof LocaleCollectionSlugRoute
  '/$locale/collections/$networkSlug': typeof LocaleCollectionsNetworkSlugRouteWithChildren
  '/$locale/mint/$dappId': typeof LocaleMintDappIdRoute
  '/$locale/profile/$userId': typeof LocaleProfileUserIdRoute
  '/$locale/validate/$authInfo': typeof LocaleValidateAuthInfoRoute
  '/$locale/wallet/$address': typeof LocaleWalletAddressRoute
  '/$locale/collections/': typeof LocaleCollectionsIndexRoute
  '/$locale/mint/': typeof LocaleMintIndexRoute
  '/$locale/profile/': typeof LocaleProfileIndexRoute
  '/$locale/validate/': typeof LocaleValidateIndexRoute
  '/$locale/collection/$chain/$slug': typeof LocaleCollectionChainSlugRoute
  '/$locale/collections/$networkSlug/$collectionSlug': typeof LocaleCollectionsNetworkSlugCollectionSlugRoute
  '/$locale/collections/$networkSlug/': typeof LocaleCollectionsNetworkSlugIndexRoute
  '/$locale/item/physical/$slug/page': typeof LocaleItemPhysicalSlugPageRoute
  '/$locale/itemdetails/$collId/$tokenId/page': typeof LocaleItemdetailsCollIdTokenIdPageRoute
  '/$locale/item/$chain/$contract/$tokenId/': typeof LocaleItemChainContractTokenIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$locale'
    | '/$locale/about'
    | '/$locale/acknowledgements'
    | '/$locale/authors'
    | '/$locale/connect-wallet'
    | '/$locale/contact'
    | '/$locale/create-item'
    | '/$locale/deploy'
    | '/$locale/dmca'
    | '/$locale/explore'
    | '/$locale/explore2'
    | '/$locale/faq'
    | '/$locale/featured'
    | '/$locale/hall-of-fame'
    | '/$locale/home'
    | '/$locale/list-item'
    | '/$locale/manage'
    | '/$locale/physical-goods'
    | '/$locale/privacy-policy'
    | '/$locale/redirect'
    | '/$locale/signin'
    | '/$locale/signup'
    | '/$locale/terms'
    | '/$locale/validate'
    | '/$locale/'
    | '/$locale/admin/minting-dapps'
    | '/$locale/chains/apothem'
    | '/$locale/chains/avalanche'
    | '/$locale/chains/coston'
    | '/$locale/chains/coston-2'
    | '/$locale/chains/flare'
    | '/$locale/chains/monad'
    | '/$locale/chains/monad-testnet'
    | '/$locale/chains/songbird'
    | '/$locale/chains/xdc'
    | '/$locale/collection/$slug'
    | '/$locale/collections/$networkSlug'
    | '/$locale/mint/$dappId'
    | '/$locale/profile/$userId'
    | '/$locale/validate/$authInfo'
    | '/$locale/wallet/$address'
    | '/$locale/collections/'
    | '/$locale/mint/'
    | '/$locale/profile/'
    | '/$locale/validate/'
    | '/$locale/collection/$chain/$slug'
    | '/$locale/collections/$networkSlug/$collectionSlug'
    | '/$locale/collections/$networkSlug/'
    | '/$locale/item/physical/$slug/page'
    | '/$locale/itemdetails/$collId/$tokenId/page'
    | '/$locale/item/$chain/$contract/$tokenId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$locale/about'
    | '/$locale/acknowledgements'
    | '/$locale/authors'
    | '/$locale/connect-wallet'
    | '/$locale/contact'
    | '/$locale/create-item'
    | '/$locale/deploy'
    | '/$locale/dmca'
    | '/$locale/explore'
    | '/$locale/explore2'
    | '/$locale/faq'
    | '/$locale/featured'
    | '/$locale/hall-of-fame'
    | '/$locale/home'
    | '/$locale/list-item'
    | '/$locale/manage'
    | '/$locale/physical-goods'
    | '/$locale/privacy-policy'
    | '/$locale/redirect'
    | '/$locale/signin'
    | '/$locale/signup'
    | '/$locale/terms'
    | '/$locale'
    | '/$locale/admin/minting-dapps'
    | '/$locale/chains/apothem'
    | '/$locale/chains/avalanche'
    | '/$locale/chains/coston'
    | '/$locale/chains/coston-2'
    | '/$locale/chains/flare'
    | '/$locale/chains/monad'
    | '/$locale/chains/monad-testnet'
    | '/$locale/chains/songbird'
    | '/$locale/chains/xdc'
    | '/$locale/collection/$slug'
    | '/$locale/mint/$dappId'
    | '/$locale/profile/$userId'
    | '/$locale/validate/$authInfo'
    | '/$locale/wallet/$address'
    | '/$locale/collections'
    | '/$locale/mint'
    | '/$locale/profile'
    | '/$locale/validate'
    | '/$locale/collection/$chain/$slug'
    | '/$locale/collections/$networkSlug/$collectionSlug'
    | '/$locale/collections/$networkSlug'
    | '/$locale/item/physical/$slug/page'
    | '/$locale/itemdetails/$collId/$tokenId/page'
    | '/$locale/item/$chain/$contract/$tokenId'
  id:
    | '__root__'
    | '/$locale'
    | '/$locale/about'
    | '/$locale/acknowledgements'
    | '/$locale/authors'
    | '/$locale/connect-wallet'
    | '/$locale/contact'
    | '/$locale/create-item'
    | '/$locale/deploy'
    | '/$locale/dmca'
    | '/$locale/explore'
    | '/$locale/explore2'
    | '/$locale/faq'
    | '/$locale/featured'
    | '/$locale/hall-of-fame'
    | '/$locale/home'
    | '/$locale/list-item'
    | '/$locale/manage'
    | '/$locale/physical-goods'
    | '/$locale/privacy-policy'
    | '/$locale/redirect'
    | '/$locale/signin'
    | '/$locale/signup'
    | '/$locale/terms'
    | '/$locale/validate'
    | '/$locale/'
    | '/$locale/admin/minting-dapps'
    | '/$locale/chains/apothem'
    | '/$locale/chains/avalanche'
    | '/$locale/chains/coston'
    | '/$locale/chains/coston-2'
    | '/$locale/chains/flare'
    | '/$locale/chains/monad'
    | '/$locale/chains/monad-testnet'
    | '/$locale/chains/songbird'
    | '/$locale/chains/xdc'
    | '/$locale/collection/$slug'
    | '/$locale/collections/$networkSlug'
    | '/$locale/mint/$dappId'
    | '/$locale/profile/$userId'
    | '/$locale/validate/$authInfo'
    | '/$locale/wallet/$address'
    | '/$locale/collections/'
    | '/$locale/mint/'
    | '/$locale/profile/'
    | '/$locale/validate/'
    | '/$locale/collection/$chain/$slug'
    | '/$locale/collections/$networkSlug/$collectionSlug'
    | '/$locale/collections/$networkSlug/'
    | '/$locale/item/physical/$slug/page'
    | '/$locale/itemdetails/$collId/$tokenId/page'
    | '/$locale/item/$chain/$contract/$tokenId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LocaleRoute: typeof LocaleRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$locale': {
      id: '/$locale'
      path: '/$locale'
      fullPath: '/$locale'
      preLoaderRoute: typeof LocaleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$locale/': {
      id: '/$locale/'
      path: '/'
      fullPath: '/$locale/'
      preLoaderRoute: typeof LocaleIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/validate': {
      id: '/$locale/validate'
      path: '/validate'
      fullPath: '/$locale/validate'
      preLoaderRoute: typeof LocaleValidateRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/terms': {
      id: '/$locale/terms'
      path: '/terms'
      fullPath: '/$locale/terms'
      preLoaderRoute: typeof LocaleTermsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/signup': {
      id: '/$locale/signup'
      path: '/signup'
      fullPath: '/$locale/signup'
      preLoaderRoute: typeof LocaleSignupRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/signin': {
      id: '/$locale/signin'
      path: '/signin'
      fullPath: '/$locale/signin'
      preLoaderRoute: typeof LocaleSigninRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/redirect': {
      id: '/$locale/redirect'
      path: '/redirect'
      fullPath: '/$locale/redirect'
      preLoaderRoute: typeof LocaleRedirectRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/privacy-policy': {
      id: '/$locale/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/$locale/privacy-policy'
      preLoaderRoute: typeof LocalePrivacyPolicyRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/physical-goods': {
      id: '/$locale/physical-goods'
      path: '/physical-goods'
      fullPath: '/$locale/physical-goods'
      preLoaderRoute: typeof LocalePhysicalGoodsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/manage': {
      id: '/$locale/manage'
      path: '/manage'
      fullPath: '/$locale/manage'
      preLoaderRoute: typeof LocaleManageRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/list-item': {
      id: '/$locale/list-item'
      path: '/list-item'
      fullPath: '/$locale/list-item'
      preLoaderRoute: typeof LocaleListItemRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/home': {
      id: '/$locale/home'
      path: '/home'
      fullPath: '/$locale/home'
      preLoaderRoute: typeof LocaleHomeRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/hall-of-fame': {
      id: '/$locale/hall-of-fame'
      path: '/hall-of-fame'
      fullPath: '/$locale/hall-of-fame'
      preLoaderRoute: typeof LocaleHallOfFameRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/featured': {
      id: '/$locale/featured'
      path: '/featured'
      fullPath: '/$locale/featured'
      preLoaderRoute: typeof LocaleFeaturedRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/faq': {
      id: '/$locale/faq'
      path: '/faq'
      fullPath: '/$locale/faq'
      preLoaderRoute: typeof LocaleFaqRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/explore2': {
      id: '/$locale/explore2'
      path: '/explore2'
      fullPath: '/$locale/explore2'
      preLoaderRoute: typeof LocaleExplore2RouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/explore': {
      id: '/$locale/explore'
      path: '/explore'
      fullPath: '/$locale/explore'
      preLoaderRoute: typeof LocaleExploreRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/dmca': {
      id: '/$locale/dmca'
      path: '/dmca'
      fullPath: '/$locale/dmca'
      preLoaderRoute: typeof LocaleDmcaRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/deploy': {
      id: '/$locale/deploy'
      path: '/deploy'
      fullPath: '/$locale/deploy'
      preLoaderRoute: typeof LocaleDeployRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/create-item': {
      id: '/$locale/create-item'
      path: '/create-item'
      fullPath: '/$locale/create-item'
      preLoaderRoute: typeof LocaleCreateItemRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/contact': {
      id: '/$locale/contact'
      path: '/contact'
      fullPath: '/$locale/contact'
      preLoaderRoute: typeof LocaleContactRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/connect-wallet': {
      id: '/$locale/connect-wallet'
      path: '/connect-wallet'
      fullPath: '/$locale/connect-wallet'
      preLoaderRoute: typeof LocaleConnectWalletRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/authors': {
      id: '/$locale/authors'
      path: '/authors'
      fullPath: '/$locale/authors'
      preLoaderRoute: typeof LocaleAuthorsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/acknowledgements': {
      id: '/$locale/acknowledgements'
      path: '/acknowledgements'
      fullPath: '/$locale/acknowledgements'
      preLoaderRoute: typeof LocaleAcknowledgementsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/about': {
      id: '/$locale/about'
      path: '/about'
      fullPath: '/$locale/about'
      preLoaderRoute: typeof LocaleAboutRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/validate/': {
      id: '/$locale/validate/'
      path: '/'
      fullPath: '/$locale/validate/'
      preLoaderRoute: typeof LocaleValidateIndexRouteImport
      parentRoute: typeof LocaleValidateRoute
    }
    '/$locale/profile/': {
      id: '/$locale/profile/'
      path: '/profile'
      fullPath: '/$locale/profile/'
      preLoaderRoute: typeof LocaleProfileIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/mint/': {
      id: '/$locale/mint/'
      path: '/mint'
      fullPath: '/$locale/mint/'
      preLoaderRoute: typeof LocaleMintIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/collections/': {
      id: '/$locale/collections/'
      path: '/collections'
      fullPath: '/$locale/collections/'
      preLoaderRoute: typeof LocaleCollectionsIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/wallet/$address': {
      id: '/$locale/wallet/$address'
      path: '/wallet/$address'
      fullPath: '/$locale/wallet/$address'
      preLoaderRoute: typeof LocaleWalletAddressRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/validate/$authInfo': {
      id: '/$locale/validate/$authInfo'
      path: '/$authInfo'
      fullPath: '/$locale/validate/$authInfo'
      preLoaderRoute: typeof LocaleValidateAuthInfoRouteImport
      parentRoute: typeof LocaleValidateRoute
    }
    '/$locale/profile/$userId': {
      id: '/$locale/profile/$userId'
      path: '/profile/$userId'
      fullPath: '/$locale/profile/$userId'
      preLoaderRoute: typeof LocaleProfileUserIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/mint/$dappId': {
      id: '/$locale/mint/$dappId'
      path: '/mint/$dappId'
      fullPath: '/$locale/mint/$dappId'
      preLoaderRoute: typeof LocaleMintDappIdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/collections/$networkSlug': {
      id: '/$locale/collections/$networkSlug'
      path: '/collections/$networkSlug'
      fullPath: '/$locale/collections/$networkSlug'
      preLoaderRoute: typeof LocaleCollectionsNetworkSlugRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/collection/$slug': {
      id: '/$locale/collection/$slug'
      path: '/collection/$slug'
      fullPath: '/$locale/collection/$slug'
      preLoaderRoute: typeof LocaleCollectionSlugRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/xdc': {
      id: '/$locale/chains/xdc'
      path: '/chains/xdc'
      fullPath: '/$locale/chains/xdc'
      preLoaderRoute: typeof LocaleChainsXdcRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/songbird': {
      id: '/$locale/chains/songbird'
      path: '/chains/songbird'
      fullPath: '/$locale/chains/songbird'
      preLoaderRoute: typeof LocaleChainsSongbirdRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/monad-testnet': {
      id: '/$locale/chains/monad-testnet'
      path: '/chains/monad-testnet'
      fullPath: '/$locale/chains/monad-testnet'
      preLoaderRoute: typeof LocaleChainsMonadTestnetRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/monad': {
      id: '/$locale/chains/monad'
      path: '/chains/monad'
      fullPath: '/$locale/chains/monad'
      preLoaderRoute: typeof LocaleChainsMonadRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/flare': {
      id: '/$locale/chains/flare'
      path: '/chains/flare'
      fullPath: '/$locale/chains/flare'
      preLoaderRoute: typeof LocaleChainsFlareRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/coston-2': {
      id: '/$locale/chains/coston-2'
      path: '/chains/coston-2'
      fullPath: '/$locale/chains/coston-2'
      preLoaderRoute: typeof LocaleChainsCoston2RouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/coston': {
      id: '/$locale/chains/coston'
      path: '/chains/coston'
      fullPath: '/$locale/chains/coston'
      preLoaderRoute: typeof LocaleChainsCostonRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/avalanche': {
      id: '/$locale/chains/avalanche'
      path: '/chains/avalanche'
      fullPath: '/$locale/chains/avalanche'
      preLoaderRoute: typeof LocaleChainsAvalancheRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/chains/apothem': {
      id: '/$locale/chains/apothem'
      path: '/chains/apothem'
      fullPath: '/$locale/chains/apothem'
      preLoaderRoute: typeof LocaleChainsApothemRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/admin/minting-dapps': {
      id: '/$locale/admin/minting-dapps'
      path: '/admin/minting-dapps'
      fullPath: '/$locale/admin/minting-dapps'
      preLoaderRoute: typeof LocaleAdminMintingDappsRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/collections/$networkSlug/': {
      id: '/$locale/collections/$networkSlug/'
      path: '/'
      fullPath: '/$locale/collections/$networkSlug/'
      preLoaderRoute: typeof LocaleCollectionsNetworkSlugIndexRouteImport
      parentRoute: typeof LocaleCollectionsNetworkSlugRoute
    }
    '/$locale/collections/$networkSlug/$collectionSlug': {
      id: '/$locale/collections/$networkSlug/$collectionSlug'
      path: '/$collectionSlug'
      fullPath: '/$locale/collections/$networkSlug/$collectionSlug'
      preLoaderRoute: typeof LocaleCollectionsNetworkSlugCollectionSlugRouteImport
      parentRoute: typeof LocaleCollectionsNetworkSlugRoute
    }
    '/$locale/collection/$chain/$slug': {
      id: '/$locale/collection/$chain/$slug'
      path: '/collection/$chain/$slug'
      fullPath: '/$locale/collection/$chain/$slug'
      preLoaderRoute: typeof LocaleCollectionChainSlugRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/itemdetails/$collId/$tokenId/page': {
      id: '/$locale/itemdetails/$collId/$tokenId/page'
      path: '/itemdetails/$collId/$tokenId/page'
      fullPath: '/$locale/itemdetails/$collId/$tokenId/page'
      preLoaderRoute: typeof LocaleItemdetailsCollIdTokenIdPageRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/item/physical/$slug/page': {
      id: '/$locale/item/physical/$slug/page'
      path: '/item/physical/$slug/page'
      fullPath: '/$locale/item/physical/$slug/page'
      preLoaderRoute: typeof LocaleItemPhysicalSlugPageRouteImport
      parentRoute: typeof LocaleRoute
    }
    '/$locale/item/$chain/$contract/$tokenId/': {
      id: '/$locale/item/$chain/$contract/$tokenId/'
      path: '/item/$chain/$contract/$tokenId'
      fullPath: '/$locale/item/$chain/$contract/$tokenId/'
      preLoaderRoute: typeof LocaleItemChainContractTokenIdIndexRouteImport
      parentRoute: typeof LocaleRoute
    }
  }
}

interface LocaleValidateRouteChildren {
  LocaleValidateAuthInfoRoute: typeof LocaleValidateAuthInfoRoute
  LocaleValidateIndexRoute: typeof LocaleValidateIndexRoute
}

const LocaleValidateRouteChildren: LocaleValidateRouteChildren = {
  LocaleValidateAuthInfoRoute: LocaleValidateAuthInfoRoute,
  LocaleValidateIndexRoute: LocaleValidateIndexRoute,
}

const LocaleValidateRouteWithChildren = LocaleValidateRoute._addFileChildren(
  LocaleValidateRouteChildren,
)

interface LocaleCollectionsNetworkSlugRouteChildren {
  LocaleCollectionsNetworkSlugCollectionSlugRoute: typeof LocaleCollectionsNetworkSlugCollectionSlugRoute
  LocaleCollectionsNetworkSlugIndexRoute: typeof LocaleCollectionsNetworkSlugIndexRoute
}

const LocaleCollectionsNetworkSlugRouteChildren: LocaleCollectionsNetworkSlugRouteChildren =
  {
    LocaleCollectionsNetworkSlugCollectionSlugRoute:
      LocaleCollectionsNetworkSlugCollectionSlugRoute,
    LocaleCollectionsNetworkSlugIndexRoute:
      LocaleCollectionsNetworkSlugIndexRoute,
  }

const LocaleCollectionsNetworkSlugRouteWithChildren =
  LocaleCollectionsNetworkSlugRoute._addFileChildren(
    LocaleCollectionsNetworkSlugRouteChildren,
  )

interface LocaleRouteChildren {
  LocaleAboutRoute: typeof LocaleAboutRoute
  LocaleAcknowledgementsRoute: typeof LocaleAcknowledgementsRoute
  LocaleAuthorsRoute: typeof LocaleAuthorsRoute
  LocaleConnectWalletRoute: typeof LocaleConnectWalletRoute
  LocaleContactRoute: typeof LocaleContactRoute
  LocaleCreateItemRoute: typeof LocaleCreateItemRoute
  LocaleDeployRoute: typeof LocaleDeployRoute
  LocaleDmcaRoute: typeof LocaleDmcaRoute
  LocaleExploreRoute: typeof LocaleExploreRoute
  LocaleExplore2Route: typeof LocaleExplore2Route
  LocaleFaqRoute: typeof LocaleFaqRoute
  LocaleFeaturedRoute: typeof LocaleFeaturedRoute
  LocaleHallOfFameRoute: typeof LocaleHallOfFameRoute
  LocaleHomeRoute: typeof LocaleHomeRoute
  LocaleListItemRoute: typeof LocaleListItemRoute
  LocaleManageRoute: typeof LocaleManageRoute
  LocalePhysicalGoodsRoute: typeof LocalePhysicalGoodsRoute
  LocalePrivacyPolicyRoute: typeof LocalePrivacyPolicyRoute
  LocaleRedirectRoute: typeof LocaleRedirectRoute
  LocaleSigninRoute: typeof LocaleSigninRoute
  LocaleSignupRoute: typeof LocaleSignupRoute
  LocaleTermsRoute: typeof LocaleTermsRoute
  LocaleValidateRoute: typeof LocaleValidateRouteWithChildren
  LocaleIndexRoute: typeof LocaleIndexRoute
  LocaleAdminMintingDappsRoute: typeof LocaleAdminMintingDappsRoute
  LocaleChainsApothemRoute: typeof LocaleChainsApothemRoute
  LocaleChainsAvalancheRoute: typeof LocaleChainsAvalancheRoute
  LocaleChainsCostonRoute: typeof LocaleChainsCostonRoute
  LocaleChainsCoston2Route: typeof LocaleChainsCoston2Route
  LocaleChainsFlareRoute: typeof LocaleChainsFlareRoute
  LocaleChainsMonadRoute: typeof LocaleChainsMonadRoute
  LocaleChainsMonadTestnetRoute: typeof LocaleChainsMonadTestnetRoute
  LocaleChainsSongbirdRoute: typeof LocaleChainsSongbirdRoute
  LocaleChainsXdcRoute: typeof LocaleChainsXdcRoute
  LocaleCollectionSlugRoute: typeof LocaleCollectionSlugRoute
  LocaleCollectionsNetworkSlugRoute: typeof LocaleCollectionsNetworkSlugRouteWithChildren
  LocaleMintDappIdRoute: typeof LocaleMintDappIdRoute
  LocaleProfileUserIdRoute: typeof LocaleProfileUserIdRoute
  LocaleWalletAddressRoute: typeof LocaleWalletAddressRoute
  LocaleCollectionsIndexRoute: typeof LocaleCollectionsIndexRoute
  LocaleMintIndexRoute: typeof LocaleMintIndexRoute
  LocaleProfileIndexRoute: typeof LocaleProfileIndexRoute
  LocaleCollectionChainSlugRoute: typeof LocaleCollectionChainSlugRoute
  LocaleItemPhysicalSlugPageRoute: typeof LocaleItemPhysicalSlugPageRoute
  LocaleItemdetailsCollIdTokenIdPageRoute: typeof LocaleItemdetailsCollIdTokenIdPageRoute
  LocaleItemChainContractTokenIdIndexRoute: typeof LocaleItemChainContractTokenIdIndexRoute
}

const LocaleRouteChildren: LocaleRouteChildren = {
  LocaleAboutRoute: LocaleAboutRoute,
  LocaleAcknowledgementsRoute: LocaleAcknowledgementsRoute,
  LocaleAuthorsRoute: LocaleAuthorsRoute,
  LocaleConnectWalletRoute: LocaleConnectWalletRoute,
  LocaleContactRoute: LocaleContactRoute,
  LocaleCreateItemRoute: LocaleCreateItemRoute,
  LocaleDeployRoute: LocaleDeployRoute,
  LocaleDmcaRoute: LocaleDmcaRoute,
  LocaleExploreRoute: LocaleExploreRoute,
  LocaleExplore2Route: LocaleExplore2Route,
  LocaleFaqRoute: LocaleFaqRoute,
  LocaleFeaturedRoute: LocaleFeaturedRoute,
  LocaleHallOfFameRoute: LocaleHallOfFameRoute,
  LocaleHomeRoute: LocaleHomeRoute,
  LocaleListItemRoute: LocaleListItemRoute,
  LocaleManageRoute: LocaleManageRoute,
  LocalePhysicalGoodsRoute: LocalePhysicalGoodsRoute,
  LocalePrivacyPolicyRoute: LocalePrivacyPolicyRoute,
  LocaleRedirectRoute: LocaleRedirectRoute,
  LocaleSigninRoute: LocaleSigninRoute,
  LocaleSignupRoute: LocaleSignupRoute,
  LocaleTermsRoute: LocaleTermsRoute,
  LocaleValidateRoute: LocaleValidateRouteWithChildren,
  LocaleIndexRoute: LocaleIndexRoute,
  LocaleAdminMintingDappsRoute: LocaleAdminMintingDappsRoute,
  LocaleChainsApothemRoute: LocaleChainsApothemRoute,
  LocaleChainsAvalancheRoute: LocaleChainsAvalancheRoute,
  LocaleChainsCostonRoute: LocaleChainsCostonRoute,
  LocaleChainsCoston2Route: LocaleChainsCoston2Route,
  LocaleChainsFlareRoute: LocaleChainsFlareRoute,
  LocaleChainsMonadRoute: LocaleChainsMonadRoute,
  LocaleChainsMonadTestnetRoute: LocaleChainsMonadTestnetRoute,
  LocaleChainsSongbirdRoute: LocaleChainsSongbirdRoute,
  LocaleChainsXdcRoute: LocaleChainsXdcRoute,
  LocaleCollectionSlugRoute: LocaleCollectionSlugRoute,
  LocaleCollectionsNetworkSlugRoute:
    LocaleCollectionsNetworkSlugRouteWithChildren,
  LocaleMintDappIdRoute: LocaleMintDappIdRoute,
  LocaleProfileUserIdRoute: LocaleProfileUserIdRoute,
  LocaleWalletAddressRoute: LocaleWalletAddressRoute,
  LocaleCollectionsIndexRoute: LocaleCollectionsIndexRoute,
  LocaleMintIndexRoute: LocaleMintIndexRoute,
  LocaleProfileIndexRoute: LocaleProfileIndexRoute,
  LocaleCollectionChainSlugRoute: LocaleCollectionChainSlugRoute,
  LocaleItemPhysicalSlugPageRoute: LocaleItemPhysicalSlugPageRoute,
  LocaleItemdetailsCollIdTokenIdPageRoute:
    LocaleItemdetailsCollIdTokenIdPageRoute,
  LocaleItemChainContractTokenIdIndexRoute:
    LocaleItemChainContractTokenIdIndexRoute,
}

const LocaleRouteWithChildren =
  LocaleRoute._addFileChildren(LocaleRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  LocaleRoute: LocaleRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
